<template>
  <div class="container-fluid">
    <h1>Modul Protokolle</h1>
    <div class="btn-toolbar p-2">
      <div class="btn-group">
        <button @click="prevPage" class="btn btn-secondary"><font-awesome-icon icon="chevron-left"/></button>
        <button @click="nextPage" class="btn btn-secondary"><font-awesome-icon icon="chevron-right"/></button>
      </div>
    </div>
    <b-table @row-clicked="openRun" striped hover :items="rows" :fields="fields" :tbody-tr-class="rowClass">
      <template v-slot:cell(remove)="data">
        <span v-if="data.item.remove" class="alert alert-warning">Deinstallation</span>
        <span v-else class="alert alert-success">Installation</span>
      </template>
    </b-table>
    <div class="wrapper">
      <b-modal id="runView" title="Protokoll" size="xl" ok-only>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Resource-ID</label>
              <input type="text" class="form-control" :value="current.id" disabled/>
            </div>
            <div class="form-group">
              <label>Zeitstempel</label>
              <input type="text" class="form-control" :value="current.exectime" disabled/>
            </div>
            <div class="form-inline">
              <label class="mr-3">Erfolg</label>
              <b-badge :variant="!current.success ? 'danger' : 'success'">{{ current.success }}</b-badge>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Modul</label>
              <input type="text" class="form-control" :value="current.module" disabled/>
            </div>
            <div class="form-group">
              <label>Version</label>
              <input type="text" class="form-control" :value="current.version" disabled/>
            </div>
            <div class="form-inline">
              <label class="mr-3">Vorgang</label>
              <b-badge v-if="current.remove" variant="warning">Deinstallation</b-badge>
              <b-badge v-else variant="success">Installation</b-badge>
            </div>
          </div>
        </div>
        <div class="container">
          <b-table striped>
          </b-table>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import conmodules from '@/modules/conmodules.js'

export default {
  name: 'ModulesAdmin',
  data() {
    return {
      pstart: 0,
      pcount: 20,
      rows: [],
      fields: [
        { key: 'id', label: 'Res-ID' },
        { key: 'module', label: 'Module' },
        { key: 'version', label: 'Version' },
        { key: 'exectime', label: 'Datum'},
        { key: 'remove', label: 'Vorgang' },
        { key: 'success', label: 'Erfolg'}
      ],
      current: {}
    }
  },
  created: function() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      var self = this;
      conmodules.listrundata(this,this.pstart,this.pcount,function(data) {
        self.rows = data;
      })
    },
    rowClass(item,type) {
      if (!item || type !== 'row') return
      if (!item.success) return 'table-danger'
    },
    nextPage() {
      this.pstart += this.pcount;
      this.fetchData();
    },
    prevPage() {
      if (this.pstart > 0) {
        this.pstart -= this.pcount;
        this.fetchData();
      }
    },
    openRun(item) {
      this.current = item;
      console.log(item);
      this.$bvModal.show('runView');
    }
  }
}
</script>
